module.exports = __webpack_public_path__ + "static/media/envelop.23a0d96d.svg";